import actions from './actions';
import { AnyAction } from 'redux';
import { SaveError } from './types';
import { ModalMode } from '../../../../../../../../redux/pages/crew-scheduling-v3/modals/interfaces';
import MODAL_MODE from '../../../../../../common/constants';

export interface BulkMaintenanceScheduleModalState {
  isSaving: boolean;
  saveError: SaveError | null;
  mxContractBulkScheduleModalMode: ModalMode;
  mxAircraftBulkScheduleModalMode: ModalMode;
}

export const initialState: BulkMaintenanceScheduleModalState = {
  isSaving: false,
  saveError: null,
  mxContractBulkScheduleModalMode: {
    open: false,
    mode: MODAL_MODE.create,
  },
  mxAircraftBulkScheduleModalMode: {
    open: false,
    mode: MODAL_MODE.create,
  },
};

export default function reducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.SET_STATE:
    case actions.SET_MX_AIRCRAFT_MODAL_MODE:
    case actions.SET_MX_CONTRACT_MODAL_MODE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
